// src/federal-districts.js
export const FEDERAL_DISTRICTS = {
  'Центральный ФО': [
    'Белгородская область','Брянская область','Владимирская область','Воронежская область',
    'Ивановская область','Калужская область','Костромская область','Курская область',
    'Липецкая область','Московская область','Орловская область','Рязанская область',
    'Смоленская область','Тамбовская область','Тверская область','Тульская область',
    'Ярославская область','г. Москва'
  ],

  'Северо-Западный ФО': [
    'Республика Карелия','Республика Коми','Ненецкий автономный округ',
    'Архангельская область','Вологодская область','Калининградская область',
    'Ленинградская область','Мурманская область','Новгородская область','Псковская область',
    'г. Санкт-Петербург'
  ],

  'Южный ФО': [
    'Республика Адыгея',
    'Краснодарский край','Астраханская область','Волгоградская область','Ростовская область',
    'г. Севастополь'
  ],

  'Северо-Кавказский ФО': [
    'Республика Дагестан','Республика Ингушетия','Кабардино-Балкарская Республика',
    'Карачаево-Черкесская Республика','Республика Северная Осетия — Алания',
    'Чеченская Республика','Ставропольский край'
  ],

  'Приволжский ФО': [
    'Республика Башкортостан','Республика Марий Эл','Республика Мордовия','Республика Татарстан',
    'Удмуртская Республика','Чувашская Республика','Кировская область',
    'Нижегородская область','Оренбургская область','Пензенская область','Пермский край',
    'Самарская область','Саратовская область','Ульяновская область'
  ],

  'Уральский ФО': [
    'Курганская область','Свердловская область','Тюменская область','Челябинская область',
    'Ханты-Мансийский автономный округ — Югра','Ямало-Ненецкий автономный округ'
  ],

  'Сибирский ФО': [
    'Республика Алтай','Республика Тыва','Республика Хакасия',
    'Алтайский край','Красноярский край',
    'Иркутская область','Кемеровская область','Новосибирская область',
    'Омская область','Томская область'
  ],

  'Дальневосточный ФО': [
    'Республика Саха (Якутия)','Республика Бурятия','Забайкальский край','Камчатский край',
    'Приморский край','Хабаровский край','Амурская область','Магаданская область',
    'Сахалинская область','Еврейская автономная область','Чукотский автономный округ'
  ],
};
